import { Props_SnippetInstitution } from './Institution.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'

const SnippetInstitution = (props: Props_SnippetInstitution) => {
    const { heading, summary, repeatable_institution, cta, columnCount, leadingImage } = props
    const classHeadingVisibility: string = heading.visibility?.value === true ? 'snippet-institution__heading--visible' : 'snippet-institution__heading--hidden'

    return (
        <section className="snippet-institution">
            <div className="snippet-institution__container">
                <div className="snippet-institution__top-content">
                    <div className={`snippet-institution__heading ${classHeadingVisibility}`}>
                        {CompileMarkdown(heading.content.value!)}
                    </div>
                    {summary.content?.value && (
                        <div className="snippet-institution__summary">
                            {CompileMarkdown(summary.content.value)}
                        </div>
                    )}
                </div>
                {leadingImage.imageSrc?.value && (
                    <a href={leadingImage.linkHref?.value} target={leadingImage.linkTarget?.value ? '_blank' : '_self'} rel={leadingImage.linkTarget?.value ? 'noopener noreferrer' : undefined} className="snippet-institution__leading-image">
                        <img loading="lazy" src={leadingImage.imageSrc.value} alt={leadingImage.imageAlt?.value ? leadingImage.imageAlt.value : ''} />
                    </a>
                )}
                <div className={`snippet-institution__grid snippet-institution__grid--cols-${columnCount.count?.value}`}>
                    {repeatable_institution.map(({ imageSrc, imageAlt, linkHref, linkTarget }, index: number) => (
                        <div key={index} className="snippet-institution__item">
                            {imageSrc?.value && (
                                linkHref?.value ? (
                                    <a
                                        href={linkHref.value}
                                        target={linkTarget?.value ? '_blank' : '_self'}
                                        rel={linkTarget?.value ? 'noopener noreferrer' : undefined}
                                        className="snippet-institution__link"
                                    >
                                        <img
                                            className="snippet-institution__image"
                                            loading="lazy"
                                            src={imageSrc.value}
                                            alt={imageAlt?.value ? imageAlt.value : ''}
                                        />
                                    </a>
                                ) : (
                                    <img
                                        className="snippet-institution__image"
                                        loading="lazy"
                                        src={imageSrc.value}
                                        alt={imageAlt?.value ? imageAlt.value : ''}
                                    />
                                )
                            )}
                        </div>
                    ))}
                </div>
                <SnippetLink
                    linkStyles={cta.linkStyle?.value}
                    className="snippet-institution__cta-link"
                    url={cta.linkHref?.value}
                    openInNewTab={cta.linkTarget?.value}
                >
                    {cta.linkText?.value}
                </SnippetLink>
            </div>
        </section>
    )
}

export default SnippetInstitution
